import React from 'react'
import styles from './MetadataList.module.css'

export interface MetaProps {
  items: string[] | React.ReactNode[]
}

const MetadataList = ({ items, ...props }: MetaProps): JSX.Element => (
  <ul data-name="Meta" className={styles.container} {...props}>
    {items.map((item, index) => (
      <li key={index} className={styles.item}>
        {item}
      </li>
    ))}
  </ul>
)

export default MetadataList
